import React from 'react';
import classes from 'classnames';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';

import { ForgotPasswordProps } from '@/types/login';
import AppInput from '../AppInput/AppInput';
import TheButton from '../TheButton/TheButton';
import AppLoaderCircle from '../AppLoaderCircle';

const ForgotPassword = ({ emitSubmit, styles, loading }: ForgotPasswordProps) => {
  const { t } = useTranslation();

  const LoginSchema = Yup.object().shape({
    email: Yup.string().required(t('validation.username_or_email_required').toString()),
  });

  const formik = useFormik({
    initialValues: {
      email: '',
    },
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: LoginSchema,
    onSubmit: emitSubmit ?? (() => {}),
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    formik.setFieldValue('email', e.target.value);
    formik.setFieldError('email', undefined);
  };

  const onClear = (event: React.MouseEvent<SVGElement, MouseEvent>, name: string) => {
    formik.setFieldValue('email', '');
    formik.setFieldError('email', undefined);
    formik.resetForm();
  };

  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        <AppInput
          className={styles.formField}
          inputWrapperClassName={classes(styles.appInputWrapper, {
            [styles.appInputWrapperError]: !!formik.errors.email,
          })}
          id='email'
          name='email'
          label={t('emailOrUsername') ?? ''}
          placeholder={t('emailOrUsername') ?? ''}
          value={formik.values?.email?.trim()}
          error={formik.errors.email}
          allowClear={true}
          emitChange={handleChange}
          emitBlur={formik.handleBlur}
          emitClear={onClear}
        />

        {!loading && (
          <TheButton
            type='submit'
            disabled={formik.isSubmitting || !formik.isValid}
            className={styles.submit}
            text={t('send')}
            shouldRecolor={false}
          />
        )}
        {loading && (
          <div className={styles.loadingWrapper}>
            <AppLoaderCircle />
          </div>
        )}
      </form>
    </>
  );
};

export default ForgotPassword;
